var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 32H64C28.625 32 0 60.641 0 96V416C0 451.359 28.625 480 64 480H448C483.375 480 512 451.359 512 416V96C512 60.641 483.312 32 448 32ZM464 416C464 424.836 456.838 432 448 432H64C55.164 432 48 424.836 48 416V144H96V328C96 350.062 113.938 368 136 368H256V336H136C131.594 336 128 332.406 128 328V270.381C130.672 270.945 133.164 272 136 272H192V240H136C131.594 240 128 236.406 128 232V144H464V416ZM288 384H416V320H288V384ZM416 224H224V288H416V224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTree);
export default __webpack_public_path__ + "static/media/table-tree.b3a3920d9bb7985beb7c553fdff10906.svg";
export { ForwardRef as ReactComponent };